<script setup>
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import NotificationContent from './NotificationContent.vue'
import { useWindowSize } from '@vueuse/core'
const { width } = useWindowSize()

const { $_, $formatNumber } = useNuxtApp()
const router = useRouter()

const userStore = useUserStore()

async function fetchNotifications() {
  userStore.fetchTopUnreadNotifications()
  userStore.fetchNotifications()
}


let pollingInterval = null

onMounted(() => {
  fetchNotifications()
  pollingInterval = setInterval(async () => {
    fetchNotifications()
  }, 1000 * 60)
})

onUnmounted(() => clearTimeout(pollingInterval))

const popoverButton = ref(null)
const close = () => {
  // close popover
  console.log("close bell")
  popoverButton?.value.el.click()
}


</script>
<template>
  <Popover class="relative" ref="popover">
    <NuxtLink v-if="width < 1024" to="/profile/notifications"
      class="relative fill-gray-800 transition hover:fill-green focus:outline-none">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29">
        <path
          d="M6.344 16.688v-5.47a6.568 6.568 0 0 1 6.562-6.562V.5h2.188v4.156a6.568 6.568 0 0 1 6.562 6.563v5.469c0 .836.476 1.788.98 2.794.595 1.187 1.208 2.417 1.208 3.768v1.094H17.28v.875A3.284 3.284 0 0 1 14 28.5a3.284 3.284 0 0 1-3.281-3.281v-.875H4.156V23.25c0-1.35.613-2.581 1.209-3.768.503-1.006.979-1.958.979-2.794Zm6.562 8.53c0 .602.492 1.095 1.094 1.095.602 0 1.094-.493 1.094-1.094v-.875h-2.188v.875Zm8.537-3.062c-.186-.541-.47-1.11-.766-1.7-.596-1.187-1.208-2.418-1.208-3.768v-5.47a4.38 4.38 0 0 0-4.375-4.374h-2.188a4.38 4.38 0 0 0-4.375 4.375v5.469c0 1.35-.612 2.58-1.208 3.768-.296.59-.58 1.159-.766 1.7h14.886Z" />
      </svg>

      <span v-if="userStore.topUnreadNotifications.length > 0"
        class="absolute -left-0.5 top-0 flex h-4 w-4 items-center justify-center rounded-full bg-red text-xs font-bold text-white">
        {{ userStore.topUnreadNotifications.length }}
      </span>
    </NuxtLink>
    <PopoverButton v-else class="relative fill-gray-800 transition hover:fill-green focus:outline-none" ref="popoverButton">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29">
        <path
          d="M6.344 16.688v-5.47a6.568 6.568 0 0 1 6.562-6.562V.5h2.188v4.156a6.568 6.568 0 0 1 6.562 6.563v5.469c0 .836.476 1.788.98 2.794.595 1.187 1.208 2.417 1.208 3.768v1.094H17.28v.875A3.284 3.284 0 0 1 14 28.5a3.284 3.284 0 0 1-3.281-3.281v-.875H4.156V23.25c0-1.35.613-2.581 1.209-3.768.503-1.006.979-1.958.979-2.794Zm6.562 8.53c0 .602.492 1.095 1.094 1.095.602 0 1.094-.493 1.094-1.094v-.875h-2.188v.875Zm8.537-3.062c-.186-.541-.47-1.11-.766-1.7-.596-1.187-1.208-2.418-1.208-3.768v-5.47a4.38 4.38 0 0 0-4.375-4.374h-2.188a4.38 4.38 0 0 0-4.375 4.375v5.469c0 1.35-.612 2.58-1.208 3.768-.296.59-.58 1.159-.766 1.7h14.886Z" />
      </svg>

      <span v-if="userStore.topUnreadNotifications.length > 0"
        class="absolute -left-0.5 top-0 flex h-4 w-4 items-center justify-center rounded-full bg-red text-xs font-bold text-white">
        {{ userStore.topUnreadNotifications.length }}
      </span>
    </PopoverButton>


    <transition enter-active-class="transition duration-200 ease-out" enter-from-class="translate-y-1 opacity-0"
      enter-to-class="translate-y-0 opacity-100" leave-active-class="transition duration-150 ease-in"
      leave-from-class="translate-y-0 opacity-100" leave-to-class="translate-y-1 opacity-0">
      <PopoverPanel
        class="absolute -right-[90px] z-20 rounded-bl-[4px] rounded-br-[4px] border-2 border-gray-300 bg-white md:left-1/2 md:-translate-x-1/2 md:transform notificationWrap"
        as="ul">

        <NotificationContent @close="close"/>
      </PopoverPanel>
    </transition>
  </Popover>
</template>
<style scoped>
.toggles {
  display: flex;
  gap: 8px;
}

.notificationText {
  display: flex;
  align-items: center;
  gap: 4px;
}

.toggle {
  border-radius: 999px;
  padding: 8px 12px;
}

.notification {
  padding: 8px 12px;
  display: flex;
  gap: 12px;
  align-items: center;
}

.toggle:not(.activeToggle):hover {
  background-color: #f1f1f1;
}

.activeToggle {
  color: rgb(26, 142, 26);
  background-color: hsl(87, 89%, 91%);
}

.notificationWrap {
  padding: 24px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  max-height: 80vh;
  width: max-content;
  max-width: 50vw;
}

.notificationWrap>li:first-child {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.notificationContent {
  list-style-type: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
